export default class AttacheSubPlan {

	constructor(name, endpoint) {
		window[name] = this.data(endpoint)
	}

	data(endpoint) {
		return {
			loading: false,
			endpoint: endpoint,
			Submit(SubPlanId) {
				var vm = this
				vm.loading = true
				var xhttp = new XMLHttpRequest();
				xhttp.open('post', this.endpoint, true);
				xhttp.setRequestHeader('Content-type', 'application/json;charset=utf-8');
				xhttp.onreadystatechange = function() {
					if (this.readyState == 4 && this.status == 200) {
						setTimeout(function() {
							vm.loading = false
							window.location.reload()
						}, 200)
					}
				}
				xhttp.send(JSON.stringify( {'uid': SubPlanId } ) );
			},
			
	
		}
	}
}